import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";

const Footer = () => {
  const navDialogRef = useRef(null);
  const navigate = useNavigate();

  const handleMenu = () => {
    if (navDialogRef.current) {
      navDialogRef.current.classList.toggle("hidden");
    }
  };

  const handleScroll = (id) => {
    navigate("/");
    setTimeout(() => {
      scroller.scrollTo(id, {
        duration: 5000,
        delay: 0,
        smooth: "easeInOutQuart",
      });
      if (navDialogRef.current) {
        navDialogRef.current.classList.add("hidden");
      }
    }, 100);
  };

  return (
    <footer className="bg-slate-50 dark:bg-black" id="contact">
      <div className="container w-[90%] mx-auto flex flex-col items-start space-y-12 px-8 pb-8 pt-12 md:flex-row md:space-y-0 md:space-x-12 md:px-12">
        {/* Company Info */}
        <div className="flex w-full flex-col space-y-4 text-center md:w-2/5 md:text-left">
          <div className="w-full text-lg font-extrabold md:w-fit md:text-left">
            <span className="text-violet-500">ByteSafe</span>
            <span className="dark:text-slate-400">Technology</span>
          </div>
          <p className="text-sm text-slate-600">
            ByteSafe Technologies excels in delivering top-notch web app
            development and cybersecurity solutions, ensuring robust digital
            security and innovation.
          </p>
        </div>

        {/* Menu */}
        <div className="w-full text-center text-slate-600 md:w-1/5 md:text-left">
          <div className="text-sm font-semibold">Menu</div>
          <ul className="text-sm">
            <li className="pt-3">
              <a
                className="underline decoration-transparent underline-offset-4 transition hover:decoration-slate-700"
                onClick={() => handleScroll("services")}
                rel="noopener noreferrer"
                target="_blank"
              >
                Services
              </a>
            </li>
            <li className="pt-3">
              <a
                className="underline decoration-transparent underline-offset-4 transition hover:decoration-slate-700"
                 href="https://www.bytesafe.in/blogs/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Blog
              </a>
            </li>
            <li className="pt-3">
              <a
                className="underline decoration-transparent underline-offset-4 transition hover:decoration-slate-700"
                onClick={() => handleScroll("about")}
                rel="noopener noreferrer"
                target="_blank"
              >
                About Us
              </a>
            </li>
            <li className="pt-3">
              <a
                className="underline decoration-transparent underline-offset-4 transition hover:decoration-slate-700"
                onClick={() => handleScroll("contact")}
                rel="noopener noreferrer"
                target="_blank"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Address */}
        <div className="w-full text-center text-slate-600 md:w-1/5 md:text-left">
          <div className="text-sm font-semibold">Address</div>
          <p className="text-sm pt-3">
            ByteSafe Technologies, office No.13, PJ Chambers, Pimpri, Maharashtra
          </p>
           
        </div>

        {/* Partnership */}
        <div className="w-full text-center text-slate-600 md:w-1/5 md:text-left">
          <div className="text-sm font-semibold text-slate-600">Contact us</div>
         
          <p className="text-sm pt-2">
           📧{" "}
              <a
                 href="mailto:email@bytesafe.in"
                 className="text-violet-600 hover:underline"
               >
                  email@bytesafe.in
              </a>
            </p>
          <div className="pt-6">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d241972.45892860444!2d73.807214!3d18.627179!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b90031dcd05b%3A0x9b73a6b6f4982cb!2sByteSafe%20Technologies!5e0!3m2!1sen!2sin!4v1722514584290!5m2!1sen!2sin"
              width="100%"
              height="150"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="container mx-auto border-t border-slate-200 p-8 text-center text-sm text-slate-600 dark:border-slate-900">
        <p>© 2024 ByteSafe. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
